/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto_Wealthlane_AwardSettlementService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto_Wealthlane_AwardSettlementService_Application_Contracts';
import type { Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto } from '../models/Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto';
import type { Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_CreateBrokerFixChannelSettingsDto } from '../models/Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_CreateBrokerFixChannelSettingsDto';
import type { Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_UpdateBrokerFixChannelSettingsDto } from '../models/Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_UpdateBrokerFixChannelSettingsDto';
import type { Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BrokerFixChannelSettingsService {

    /**
     * @param id 
     * @returns Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppBrokerFixChannelSettings(
id: string,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/broker-fix-channel-settings/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto OK
     * @throws ApiError
     */
    public static putApiAwardSettlementApiAppBrokerFixChannelSettings(
id: string,
requestBody?: Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_UpdateBrokerFixChannelSettingsDto,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award-settlement/api/app/broker-fix-channel-settings/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardSettlementApiAppBrokerFixChannelSettings(
id: string,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award-settlement/api/app/broker-fix-channel-settings/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param brokerCompanyId 
     * @returns Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppBrokerFixChannelSettingsByBrokerCompany(
brokerCompanyId: string,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/broker-fix-channel-settings/by-broker-company/{brokerCompanyId}',
            path: {
                'brokerCompanyId': brokerCompanyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto_Wealthlane_AwardSettlementService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppBrokerFixChannelSettingsPaginatedList(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto_Wealthlane_AwardSettlementService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/broker-fix-channel-settings/paginated-list',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppBrokerFixChannelSettings1(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/broker-fix-channel-settings',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppBrokerFixChannelSettings(
requestBody?: Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_CreateBrokerFixChannelSettingsDto,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/broker-fix-channel-settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
